import React from 'react'
import { withFirebase } from './components/Firebase';
import * as emailjs from 'emailjs-com' 
import CustomNavbar from './components/CustomNavBar'
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';


class Failed extends React.Component {
  constructor(props) {
    super(props);

  }

componentDidMount(){


}

  render() {

    return( 
      <div style={{height:'100%'}}>
      <div style={{minHeight:'92vh'}}>
      <CustomNavbar logo={true}></CustomNavbar>

      <Grid container direction="column" justify={'center'} alignItems={'center'} style={{marginLeft:'-10px' ,paddingTop:'30px'}}>
        <Typography variant="h4" style={{marginTop:'5px',paddingBottom:'5px', color:'black', maxWidth:"80%", textAlign:'center'}}>
           Payment was unsuccessful.
        </Typography>  
        <Typography variant="subtitle1" style={{marginTop:'5px',paddingBottom:'5px', color:'black', maxWidth:"80%", textAlign:'center'}}>
           Please try again or contact truenorthsailingsoftware@gmail.com for help.
        </Typography> 
      </Grid>
      </div>
 
      <div style={{minHeight:'8vh', boxShadow:'0 0px 12px 0 rgba(0, 0, 0, 0.4), 0 0px 20px 0 rgba(0, 0, 0, 0.4)', backgroundColor:'#313131'}}>
      <Grid container direction="row" justify={'center'} alignItems={'center'} style={{height:'8vh'}}>
      <Typography variant="body2" style={{color:'white'}}>
                    Contact us at truenorthsailingsoftware@gmail.com | +27 84 600 6091
      </Typography>
      </Grid>
      </div> 


      </div>
    )

  }
}

export default Failed

